import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import Header from "../../layouts/Header";
import CancelWarningModal from "../../components/Dailogs/CancelWarningModal";
import Xicon from "../../assets/icons/Xicon.svg";
import DownArrowOption from "../../assets/icons/DownArrowOption.svg";
import searchicon from "../../assets/icons/search.svg";
import "../../assets/styles/local/OrderPickingList.css";
import "../../assets/styles/local/asc_Custom_Select_Box.css";
import Pagination from "../../components/Pagination/Pagination";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import {
  ProjectDropdown,
  AddOrderPicking,
  FetchPhaseMaterialsByProject,
  FetchPOByProject,
  FetchPurchasingOrder,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import { ADD_ORDER_PICKING } from "../../redux/constants/type";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import RouteLeavingGuard from "../../components/Common/RouteLeavingGuard";

const OrderPickingList = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const Project_Popup_Ref = useRef(null);
  const Project_Item_Popup_Ref = useRef(null);

  const fetchProjectDropdown = useSelector(
    (state) => state.user.fetchProjectDropdown,
  );

  const addOrderPickingRes = useSelector(
    (state) => state.user.addOrderPickingRes,
  );

  const fetchPhaseMaterialsByProjectRes = useSelector(
    (state) => state.user.fetchPhaseMaterialsByProjectRes,
  );

  const fetchPOByProjectResponse = useSelector(
    (state) => state.user.fetchPOByProjectResponse,
  );

  const fetchPurchasingOrder = useSelector(
    (state) => state.user.fetchPurchasingOrder,
  );

  const [cancelPopupShow, setCancelPopupShow] = useState(false);
  const handleClose = () => setCancelPopupShow(false);

  const handleCancel = (e) => {
    history.goBack();
  };
  const [typeInScreen, setTypeInScreen] = useState("");
  const [querystring, setQuerystring] = useState("");
  const [searchProjectName, setSearchProjectName] = useState("");
  const [searchProjectItemName, setSearchProjectItemName] = useState("");
  const [projectName, setProjectName] = useState("");
  const [projectItemName, setProjectItemName] = useState("");
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  const [listData, setListData] = useState([]);
  const [single, setSingle] = useState(false);
  const [list, setList] = useState(true);
  const [clientAddress, setClientAddress] = useState("");
  const [clientCountry, setClientCountry] = useState("");
  const [projectData, setProjectData] = useState([]);
  const [projectListData, setProjectListData] = useState([]);
  const [projectid, setProjectid] = useState("");
  const [projectItemId, setProjectItemId] = useState("");
  const [projectShowOptions, setProjectShowOptions] = useState(false);
  const [projectItemShowOptions, setProjectItemShowOptions] = useState(false);
  const [arrowOptionsRotate, setArrowOptionsRotate] = useState(false);
  const [arrowItemOptionsRotate, setArrowItemOptionsRotate] = useState(false);

  const [listHover, setListHover] = useState(false);
  const [asc_ProductPartid, setAsc_ProductPartid] = useState("");
  const [asc_Itemdescription, setAsc_Itemdescription] = useState("");

  useEffect(() => {
    dispatch(ProjectDropdown());
  }, [dispatch]);

  useEffect(() => {
    // if (projectid) dispatch(FetchPhaseMaterialsByProject(projectid));
  }, [projectid, dispatch]);

  useEffect(() => {
    if (fetchPhaseMaterialsByProjectRes.status) {
      const val = fetchPhaseMaterialsByProjectRes.data;
      // setProjectListData(val);
    }
  }, [fetchPhaseMaterialsByProjectRes]);

  useEffect(() => {
    if (projectid)
      dispatch(
        FetchPOByProject(
          projectid,
          "Purchasing", // pageNumber,// itemsPerPage,
        ),
      );
  }, [projectid, dispatch]);

  useEffect(() => {
    if (fetchPOByProjectResponse.status) {
      const val = fetchPOByProjectResponse.data;
      setProjectListData(val);
    }
  }, [fetchPOByProjectResponse]);

  useEffect(() => {
    fetchScreenTranslations("Order Picking").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  useEffect(() => {
    if (fetchProjectDropdown?.status) {
      setProjectData(fetchProjectDropdown?.data);
    }
  }, [fetchProjectDropdown]);

  // add order picking api res start
  useEffect(() => {
    if (addOrderPickingRes?.status) {
      setSearchProjectName("");
      setSearchProjectItemName("");
      setProjectName("");
      setProjectItemName("");
      setProjectid("");
      setProjectItemId("");
      setListData([]);
      setProjectListData([]);

      handleGeneralNotification(
        {
          notificationType: "CUSTOM",
          text: ` Great Job! The product was picked for the project.`,
        },
        false,
      );
      dispatch({
        type: ADD_ORDER_PICKING,
        data: {},
      });
    } else if (addOrderPickingRes?.status === false) {
      handleGeneralNotification(
        {
          notificationType: "CUSTOM",
          text: `something went wrong!`,
        },
        false,
      );
      dispatch({
        type: ADD_ORDER_PICKING,
        data: {},
      });
    }
  }, [addOrderPickingRes?.status, dispatch]);
  // add order picking api res end

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      Project_Popup_Ref.current &&
      !Project_Popup_Ref.current.contains(event.target)
    ) {
      setProjectShowOptions(false);
      setArrowOptionsRotate(false);
    }

    if (
      Project_Item_Popup_Ref.current &&
      !Project_Item_Popup_Ref.current.contains(event.target)
    ) {
      setProjectItemShowOptions(false);
      setArrowItemOptionsRotate(false);
    }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  const handleOrderPicking = () => {
    if (
      listData
        .filter((x) => x.isCheck)
        .some(
          (item) =>
            item.newQtyToPick === 0 ||
            item.instock.quantity === 0 ||
            item.currentQuantity === 0 ||
            item.newQtyToPick > item.instock.quantity ||
            item.newQtyToPick > item.currentQuantity,
        )
    ) {
      handleGeneralNotification(
        {
          notificationType: "CUSTOM",
          text: `Please adjust qty to pick according to a stock`,
        },
        false,
      );
      return;
    }
    let payload = listData
      .filter((x) => x.isCheck && x.newQtyToPick > 0)
      .map((x) => ({
        productid: x.productid,
        orderproductqty: x.newQtyToPick,
      }));

    dispatch(AddOrderPicking(projectid, "", payload));
  };

  document.getElementById("asc_input")?.focus();

  const projectFinalList_Old =
    projectListData?.length > 0 &&
    projectListData?.filter((item) => item.phaseId === projectItemId)[0]
      ?.phaseMaterials;

  const projectFinalList =
    fetchPurchasingOrder?.data?.length > 0 &&
    fetchPurchasingOrder?.data?.filter(
      (item) => item.orderid === projectItemId,
    )[0]?.orderproduct;

  const handleQtyToPickChange = (e, item) => {
    e.preventDefault();
    const { value } = e.target;
    const newValue = Number(value);
    if (newValue > item.instock.quantity || newValue > item.orderproductqty) {
      handleGeneralNotification(
        {
          notificationType: "CUSTOM",
          text: `You can't pick more than stock quantity and QtyToPick`,
        },
        false,
      );
      return;
    }
    let data = [...projectFinalList];
    let productIndex = data.findIndex(
      (arg) => arg.productid === item.productid,
    );
    data[productIndex]["newQtyToPick"] = newValue;
    data[productIndex]["isCheck"] = true;
    setListData(data);
  };

  // asc for disable Add Button start.
  let disableData = listData?.some((item) => item.isCheck);

  // asc for disable Add Button end.

  return (
    <mainSection>
      <Header
        setQuery={setQuerystring}
        leftComponent={
          <div className="products-and-parts-header-content">
            <div
              className="products-and-parts-main-title  cursor-pointer"
              onClick={() => {
                history.push("/stock");
              }}
            >
              {/* Stock */}
              {t("Stock")}
            </div>
            <p className="products-and-parts-sub-title">
              {/* Order Picking */}
              {t("Order Picking")}
            </p>

            <div className="d-flex mainSwitch ms-5 pointer">
              <div
                className={
                  single ? "singleSwitch px-4 py-1" : "noSwitch px-4 py-1"
                }
                onClick={() => {
                  setSingle(true);
                  setList(false);
                  history.push("/order-picking");
                }}
              >
                {/* Single */}
                {t("Single")}
              </div>
              <div
                className={list ? "listSwitch px-4 py-1" : "noSwitch px-4 py-1"}
                onClick={() => {
                  setList(true);
                  setSingle(false);
                  history.push("/OrderPickingList");
                }}
              >
                {/* List */}
                {t("List")}
              </div>
            </div>
          </div>
        }
      />

      {cancelPopupShow && (
        <CancelWarningModal
          show={cancelPopupShow}
          // onHide={() => setCancelPopupShow(false)}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          handleCancel={handleCancel}
        />
      )}
      <RouteLeavingGuard
        when={typeInScreen !== ""}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={(location) => {
          // if (typeInScreen !== "") {
          //   if (
          //     !["/stock"].includes(location.pathname)
          //   ) {
          //     return true;
          //   }
          // }
          return false;
        }}
      />

      <headerSection>
        <div className="ps-5 d-flex gap-4 flex-wrap">
          <p className="pick_project pt-3">
            {/* Project */}
            {t("Project")}
          </p>

          <projectSection>
            <div
              className="asc_Search_Box shadow-none d-flex"
              ref={Project_Popup_Ref}
              style={{
                background: "white",
              }}
            >
              <p
                className="font-weight-normal asc_Client_Input_For_Long ps-3"
                onClick={() => {
                  setProjectShowOptions(!projectShowOptions);
                  setArrowOptionsRotate(!arrowOptionsRotate);
                }}
              >
                {/* {projectName ? projectName : "Select a Project"} */}
                {projectName ? projectName : t("Select  a project")}

                <br />
                <p className="clintAddress pt-2">{clientAddress}</p>
                <p className="clintAddress">{clientCountry}</p>
              </p>

              {projectName ? (
                <img
                  src={Xicon}
                  className="xicon pointer mt-2"
                  alt=""
                  onClick={() => {
                    setSearchProjectName("");
                    setProjectName("");
                    setProjectid("");
                    setClientAddress("");
                    setClientCountry("");
                    setTypeInScreen("asc");
                    setArrowOptionsRotate(false);
                    setProjectListData([]);
                    setProjectItemId("");
                    setProjectItemName("");
                    setSearchProjectItemName("");
                    setProjectItemShowOptions(false);
                    setArrowItemOptionsRotate(false);
                    setListData([]);
                  }}
                />
              ) : (
                <img
                  src={DownArrowOption}
                  className={
                    arrowOptionsRotate
                      ? "upArrow mt-1 pointer"
                      : "downArrow mt-1 pointer"
                  }
                  alt=""
                  onClick={() => {
                    setProjectShowOptions(!projectShowOptions);
                    setArrowOptionsRotate(!arrowOptionsRotate);
                  }}
                />
              )}

              {projectShowOptions && (
                <div
                  className="asc_Custom_Select_Outer"
                  style={{
                    borderTop: "none",
                    background: "white",
                    zIndex: "2",
                    top: "54px",
                  }}
                >
                  <section className="asc_Search_Icon_Search mx-2">
                    <img
                      src={searchicon}
                      className="asc_searchicon"
                      alt="Search Icon"
                    />
                    <input
                      id="asc_input"
                      className="asc_Search_Input"
                      // placeholder="Search..."
                      placeholder={t("Search")}
                      value={searchProjectName}
                      onChange={(e) => setSearchProjectName(e.target.value)}
                    />
                  </section>

                  <section
                    className="asc_Search_List pt-0 p-0"
                    id="ascSelectBox"
                  >
                    {projectData
                      .filter(
                        (item) =>
                          item.projectname
                            ?.toLowerCase()
                            .includes(searchProjectName.toLowerCase()) ||
                          item.projectcode
                            ?.toLowerCase()
                            .includes(searchProjectName.toLowerCase()),
                      )
                      .map((item, index) => {
                        return (
                          <div
                            key={index}
                            className="ulterDrop"
                            onClick={() => {
                              setSearchProjectName("");
                              setProjectName(item.projectname);
                              setProjectid(item.projectid);
                              setProjectShowOptions(false);
                              setTypeInScreen("asc");
                              setArrowOptionsRotate(false);
                              setProjectListData([]);
                              setProjectItemId("");
                              setProjectItemName("");
                              setSearchProjectItemName("");
                              setProjectItemShowOptions(false);
                              setArrowItemOptionsRotate(false);
                              setListData([]);
                            }}
                          >
                            <p
                              className={
                                projectid === item.projectid
                                  ? "asc_Selected_Item mb-0 ps-"
                                  : "mb-0 ps-"
                              }
                            >
                              {item?.projectcode}&nbsp;┃&nbsp;
                              {item.projectname.length > 25
                                ? item.projectname.slice(0, 25) + "..."
                                : item.projectname}
                            </p>
                          </div>
                        );
                      })}
                    {/* Display a message when no projects are found */}
                    {projectData.length > 0 &&
                      projectData.filter((item) =>
                        item.projectname
                          ?.toLowerCase()
                          .includes(searchProjectName.toLowerCase()),
                      ).length === 0 && (
                        <span className="ps-3">
                          {/* No projects found! */}
                          {t("No projects found!")}
                        </span>
                      )}

                    {/* Display a message when no data to display */}
                    {projectData.length === 0 && (
                      <span className="noDataDisplay">
                        {/* No data to display! */}
                        {t("No data to display!")}
                      </span>
                    )}
                  </section>
                  {/* for button start*/}
                  <button
                    className="makeInvoBtn w-50 my-4"
                    style={{ marginLeft: "25%" }}
                    onClick={() => {
                      history.push("/addProject", "/project");
                    }}
                  >
                    {/* Create a Project */}
                    {t("Create a Project")}
                  </button>
                  {/* for button end*/}
                </div>
              )}
            </div>
          </projectSection>

          <p className="pick_project pt-3">
            {/* List */}
            PO {t("List")}
          </p>
          <projectSection>
            <div
              className="asc_Search_Box d-flex shadow-none"
              ref={Project_Item_Popup_Ref}
              style={{
                background: "white",
              }}
            >
              <p
                className="font-weight-normal asc_Client_Input_For_Long ps-3"
                onClick={() => {
                  setProjectItemShowOptions(!projectItemShowOptions);
                  setArrowItemOptionsRotate(!arrowItemOptionsRotate);
                }}
              >
                {/* {projectItemName ? projectItemName : "Select a List"} */}
                {projectItemName ? projectItemName : t("Select a list")}
              </p>

              {projectItemName ? (
                <img
                  src={Xicon}
                  className="xicon pointer mt-2"
                  alt=""
                  onClick={() => {
                    setSearchProjectItemName("");
                    setProjectItemName("");
                    setProjectItemId("");
                    setTypeInScreen("asc");
                    setArrowItemOptionsRotate(false);
                  }}
                />
              ) : (
                <img
                  src={DownArrowOption}
                  className={
                    arrowItemOptionsRotate
                      ? "upArrow mt-1 pointer"
                      : "downArrow mt-1 pointer"
                  }
                  alt=""
                  onClick={() => {
                    setProjectItemShowOptions(!projectItemShowOptions);
                    setArrowItemOptionsRotate(!arrowItemOptionsRotate);
                  }}
                />
              )}

              {projectItemShowOptions && (
                <div
                  className="asc_Custom_Select_Outer"
                  style={{
                    borderTop: "none",
                    background: "white",
                    zIndex: "2",
                    top: "54px",
                  }}
                >
                  <section className="asc_Search_Icon_Search mx-2">
                    <img
                      src={searchicon}
                      className="asc_searchicon"
                      alt="Search Icon"
                    />
                    <input
                      id="asc_input"
                      className="asc_Search_Input"
                      // placeholder="Search..."
                      placeholder={t("Search")}
                      value={searchProjectItemName}
                      onChange={(e) => setSearchProjectItemName(e.target.value)}
                    />
                  </section>

                  <section
                    className="asc_Search_List pt-0 p-0"
                    id="ascSelectBox"
                  >
                    {projectListData
                      .filter((item) =>
                        item.suppliername
                          ?.toLowerCase()
                          .includes(searchProjectItemName.toLowerCase()),
                      )
                      .map((item, index) => {
                        return (
                          <div
                            key={index}
                            className="ulterDrop"
                            onClick={() => {
                              setSearchProjectItemName("");
                              setProjectItemName(item.suppliername);
                              // setProjectItemId(item.supplierid);
                              setProjectItemId(item.orderid);
                              setProjectItemShowOptions(false);
                              setTypeInScreen("asc");
                              dispatch(FetchPurchasingOrder(item.orderid));
                            }}
                          >
                            <p
                              className={
                                projectItemId === item.orderid
                                  ? "asc_Selected_Item mb-0 ps-"
                                  : "mb-0 mb-0 ps-"
                              }
                            >
                              {item?.ordercode}&nbsp;┃&nbsp;
                              {item.suppliername.length > 25
                                ? item.suppliername.slice(0, 25) + "..."
                                : item.suppliername}
                            </p>
                          </div>
                        );
                      })}
                    {projectListData.length > 0 &&
                      projectListData.filter((item) =>
                        item.suppliername
                          ?.toLowerCase()
                          .includes(searchProjectItemName.toLowerCase()),
                      ).length === 0 && (
                        <span className="ps-3">No items found!</span>
                      )}

                    {projectListData.length === 0 && (
                      <span className="ps-3">
                        {/* No data to display! */}
                        {t("No data to display!")}
                      </span>
                    )}
                  </section>
                </div>
              )}
            </div>
          </projectSection>

          <div className="ms-auto me-1 me-sm-5 d-flex flex-wrap gap-3 pt-2 threeButtons">
            <button
              className="mb-0 cancelBtn"
              onClick={() => {
                if (typeInScreen !== "") {
                  setCancelPopupShow(true);
                } else {
                  // history.goBack();
                  history.push("/stock");
                }
              }}
            >
              {/* Cancel */}
              {t("Cancel")}
            </button>

            <button
              className="mb-0 makeInvoBtn"
              style={{
                cursor:
                  projectid === "" ||
                  projectItemId === "" ||
                  disableData === false
                    ? "not-allowed"
                    : "pointer",
              }}
              disabled={
                projectid === "" ||
                projectItemId === "" ||
                disableData === false
              }
              onClick={() => {
                handleOrderPicking();
              }}
            >
              {/* Add */}
              {t("Add")}
            </button>
          </div>
        </div>
      </headerSection>

      <tableSection>
        <section className="pt-3">
          <div
            className="ascTableWrapper pt-3 mx-5"
            style={{ borderRadius: "15px" }}
          >
            <table className="table">
              <thead>
                <tr
                  className="tableHeading-NewInvoice"
                  style={{
                    borderBottom: "0.5px solid #a5a5a569",
                    top: "-16px",
                    zIndex: "1",
                  }}
                >
                  <th className="ps-5" style={{ width: "35%" }}>
                    {t("Item Name")}
                    {/* Item Name */}
                  </th>
                  <th style={{ width: "15%" }}>{t("Item Id")}</th>
                  <th style={{ width: "15%" }}>
                    Kg
                    {/* {FetchTranslationList[19]?.translation} */}
                  </th>
                  <th style={{ width: "15%" }}>{t("In Stock")}</th>
                  <th style={{ width: "10%" }}>{t("Aisle")}</th>
                  <th style={{ width: "10%" }}>{t("Row")}</th>
                  <th style={{ width: "10%" }}>{t("Bin")}</th>
                  <th className="text-end pe-4">{t("Qty to Pick")}</th>
                </tr>
              </thead>

              <tbody
                className="tabLine"
                style={{ borderTop: "none", background: "white" }}
              >
                {projectFinalList?.length > 0 &&
                  projectFinalList
                    ?.filter(
                      (item) =>
                        item.productcode
                          ?.toLowerCase()
                          .includes(querystring.toLowerCase()) ||
                        item.productname
                          ?.toLowerCase()
                          .includes(querystring.toLowerCase()) ||
                        item.productdescription
                          ?.toLowerCase()
                          .includes(querystring.toLowerCase()) ||
                        item.suppliercode
                          ?.toLowerCase()
                          .includes(querystring.toLowerCase()),
                    )
                    ?.map((item, index) => {
                      return (
                        <tr
                          style={{ borderColor: "#e8e0e0" }}
                          key={index}
                          className={`TableRowClass bg-transparent ${item?.ispicked === 1 && "pointerNone"}`}
                        >
                          <td className="ps-5">
                            <div
                              className="d-flex gap-1"
                              style={{ position: "relative" }}
                            >
                              <input
                                class="form-check-input pointer"
                                type="checkbox"
                                id="ascInvoice"
                                checked={
                                  item.ispicked === 1 || item?.isCheck
                                    ? true
                                    : false
                                }
                                onClick={(e) => {
                                  let data = [...projectFinalList];
                                  let productIndex = data.findIndex(
                                    (arg) => arg.materialId === item.materialId,
                                  );
                                  data[productIndex]["isCheck"] =
                                    e.target.checked;
                                  data[productIndex]["newQtyToPick"] =
                                    item.currentQuantity;
                                  setListData(data);
                                }}
                              />
                              <textHoverSection>
                                {listHover &&
                                  asc_ProductPartid === item?.productid &&
                                  item?.productname?.length > 30 && (
                                    <div className="textHoverSection">
                                      <h6>
                                        {item?.productname?.length > 30 &&
                                          asc_Itemdescription}
                                      </h6>
                                    </div>
                                  )}
                              </textHoverSection>
                              <p
                                onMouseEnter={() => {
                                  setListHover(true);
                                  setAsc_ProductPartid(item?.productid);
                                  setAsc_Itemdescription(item?.productname);
                                }}
                                onMouseLeave={() => {
                                  setListHover(false);
                                  setAsc_ProductPartid("");
                                  setAsc_Itemdescription("");
                                }}
                              >
                                {item?.productname?.length > 30
                                  ? item?.productname?.slice(0, 30) + "..."
                                  : item?.productname}
                              </p>
                            </div>
                          </td>
                          <td>{item?.productcode}</td>
                          <td>{item?.unit}</td>
                          <td>{item?.instock?.quantity}</td>
                          <td>{item?.aisle}</td>
                          <td>{item?.row}</td>
                          <td>{item?.bin}</td>
                          <td
                            className="text-end pe-4"
                            style={{
                              background: "#FAFAFA",
                            }}
                          >
                            <input
                              className={
                                item.isCheck
                                  ? "highlightedInput text-end"
                                  : "orderPickInput text-end"
                              }
                              type="number"
                              min="0"
                              max={item?.currentQuantity}
                              // value={item?.newQtyToPick ?? item?.quantity ?? 0}
                              value={
                                // item?.newQtyToPick ?? item?.currentQuantity ?? 0
                                item?.newQtyToPick ?? item?.orderproductqty ?? 0
                              }
                              onChange={(e) => handleQtyToPickChange(e, item)}
                            />
                          </td>
                        </tr>
                      );
                    })}
              </tbody>
            </table>
          </div>

          {/* {projectFinalList?.length > 0 && (
            <div className="mx-5">
              <Pagination
                perPage={perPage}
                setPerPage={setPerPage}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPages={totalPages}
              />
            </div>
          )} */}
        </section>
      </tableSection>
    </mainSection>
  );
};

export default OrderPickingList;
